export var SERVICE;
(function (SERVICE) {
  SERVICE[SERVICE["ADSL"] = 0] = "ADSL";
  SERVICE[SERVICE["GAS"] = 1] = "GAS";
  SERVICE[SERVICE["LIGHT"] = 2] = "LIGHT";
  SERVICE[SERVICE["LIGHT_GAS"] = 3] = "LIGHT_GAS";
  SERVICE[SERVICE["MORTGAGE"] = 4] = "MORTGAGE";
})(SERVICE || (SERVICE = {}));
export var serviceStringValues = {
  [SERVICE.ADSL]: "ADSL",
  [SERVICE.GAS]: "GAS",
  [SERVICE.LIGHT]: "LUCE",
  [SERVICE.LIGHT_GAS]: "DUALFUEL",
  [SERVICE.MORTGAGE]: "MUTUO"
};